"use client";

/**
 * Global Error Page — Nuclear Fallback
 *
 * Catches errors in the root layout itself (layout.tsx).
 * Since the layout is dead when this renders, it CANNOT use
 * Tailwind or globals.css — must use inline styles only.
 *
 * This is extremely rare but prevents a blank white screen
 * if the layout crashes.
 */

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Log synchronously — useEffect is supported in global-error.tsx
  // eslint-disable-next-line no-console
  typeof window !== "undefined" && console.error("[GlobalError] Root layout crash:", error);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
          backgroundColor: "#1a1017",
          color: "#f0e8dd",
          padding: "1rem",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "360px" }}>
          {/* Warning triangle (inline SVG) */}
          <div
            style={{
              margin: "0 auto 1.5rem",
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "rgba(217, 148, 78, 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="32" height="32" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#d9944e">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
            </svg>
          </div>

          <h1 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: "0.5rem" }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: "0.875rem", color: "#a293a0", marginBottom: "2rem" }}>
            Your session has ended. Please reload to continue.
          </p>

          <button
            onClick={() => window.location.reload()}
            style={{
              width: "100%",
              padding: "0.75rem 1.5rem",
              backgroundColor: "#d9944e",
              color: "#1a1017",
              border: "none",
              borderRadius: "0.75rem",
              fontSize: "0.875rem",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Reload Page
          </button>
        </div>
      </body>
    </html>
  );
}
